export const PATIENT_LABEL = 'Patient';
export const PATIENT_NAME_LABEL = 'Patient name';
export const PATIENT_SURNAME_LABEL = 'Patient surname';
export const PATIENT_EMAIL_LABEL = 'Patient email';
export const CLINIC_PATIENT_ID_LABEL = 'Clinic Patient ID';

// Compatibility aliases for Vets-origin components. Physio keeps patient-only naming.
export const CLIENT_LABEL = PATIENT_LABEL;
export const CLIENT_NAME_LABEL = PATIENT_SURNAME_LABEL;
